export default [
  {
    userId: 1,
    postId: 10000,
    image:
      "https://www.yellowcabnyctaxi.com/wp-content/uploads/2016/08/taxi-1-1024x684.jpg",
    title: "Welcome to the digital era",
    date: "1 January, 2018",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    views: 135,
    comments: [
      {
        name: "John Doe",
        date: "14 January, 2018",
        content:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      }
    ]
  },
  {
    userId: 1,
    postId: 10001,
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/TAXI.jpg/1200px-TAXI.jpg",
    title: "How to drive your taxi for 16 hours without being bored",
    date: "20 January, 2018",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    views: 47,
    comments: [
      {
        name: "John Doe",
        date: "15 February, 2018",
        content:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      },
      {
        name: "Johanna Doe",
        date: "8 March, 2018",
        content:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
      }
    ]
  },
  {
    userId: 2,
    postId: 10002,
    image:
      "https://s3-media2.fl.yelpcdn.com/bphoto/bZXKVV6WDWxD_mTlScgmhA/o.jpg",
    title: "Big taxis are better",
    date: "3 January, 2018",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    views: 12,
    comments: []
  }
];



// WEBPACK FOOTER //
// ./src/data/posts.js